import * as React from 'react';
import * as S from './styles';
import { SpecialHour } from 'features/Dealers/Listings/SpecialHours/state/types';
import { parseHoursTo12Format, parseStringDateToDate } from 'features/Dealers/Listings/Data/state/utils';

export interface ViewSpecialHoursProps {
  specialHoursState: SpecialHour[];
}

const ViewSpecialHours: React.FC<ViewSpecialHoursProps> = (props) => {

  return (
    <S.ViewSpecialHourContainer>
      <S.ViewSpecialHourSection>
        <S.ViewSpecialHourList>
          {
            props.specialHoursState.map((specialHour, index) => {
              return (
                <S.ViewSpecialHourLabel key={index}>
                  <S.ViewSpecialHourLabelDescription>
                    {parseStringDateToDate(specialHour.startDate ?? "")}
                  </S.ViewSpecialHourLabelDescription>
                  <S.ViewSpecialHourLabelStatus>
                    {
                      specialHour.is24hrs ? "Opened 24 hours" : specialHour.isClosed ? "Closed" :
                      parseHoursTo12Format(specialHour.openTime, specialHour.closeTime)
                    }
                  </S.ViewSpecialHourLabelStatus>
                </S.ViewSpecialHourLabel>
              )
            })
          }
        </S.ViewSpecialHourList>
      </S.ViewSpecialHourSection>
    </S.ViewSpecialHourContainer>
  )
}

export default ViewSpecialHours